$('.faq__question').click(function(e){
    e.preventDefault();
    $(this).siblings().toggleClass('open')
    $(this).parent().toggleClass('open')
})